import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommunicationService } from '../../services/communication/communication.service';

@Component({
    selector: 'app-browser-support',
    templateUrl: './browser-support.component.html',
    styleUrls: ['./browser-support.component.scss'],
    standalone: false
})
export class BrowserSupportComponent {
  companyId: number;

  nonIEFeatures = ['Coaching Module'];

  browserList = [
    { name: 'Google Chrome', downloadLink: 'https://www.google.com/intl/en_in/chrome/' },
    { name: 'Mozilla Firefox', downloadLink: 'https://www.mozilla.org/en-US/firefox/new/' },
    { name: 'Safari', downloadLink: 'https://support.apple.com/downloads/safari' },
    { name: 'Microsoft Edge', downloadLink: 'https://www.microsoft.com/en-us/edge' }
  ];

  constructor(
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
  ) {
    this.companyId = this.route.snapshot.queryParams.cid;
    this.communicationService.sendCompanyId(this.companyId);
  }

}
